<template>
	<div>
		<h1>404</h1>
		<article>
			<p>Page Not Found</p>
		</article>
	</div>
</template>

<script>
	export default {
		name:"page404",
		data(){
			return {
				
			};
		}
	}
</script>

<style>
</style>
